const MotivationalQuotesUtil = {
    generateRandomMotivationQuote: function() {
        let quotes = [
            'Ничто так не заразительно, как энтузиазм. (Сэмюэл Кольридж)',
            'В учении нельзя останавливаться. (Сюнь-цзы)',
            'Знания, за которые платят, запоминаются лучше. (Рабби Нахман)',
            'Лучше весь век учиться, нежели пребыть незнающим. (Суворов А. В.)',
            'Учиться надо всю жизнь, до последнего дыхания! (Сюнь-Цзы)',
            'Никто по-настоящему никогда не перестаёт учиться. (Иоганн Гёте)',
            'Учитесь так, словно вы постоянно ощущаете нехватку своих знаний, и так, словно вы постоянно боитесь растерять свои знания. (Конфуций)',
            'Я никогда не учу своих учеников. Я только даю условия, при которых они могут сами учиться. (А. Эйнштейн)',

            'Границы моего языка — это границы моего мира. (Людвиг Витгенштейн)',
            'Владеть другим языком — значит обладать второй душой. (Карл Великий)',
            'Инвестиции в знания платят лучшие дивиденды. (Бенджамин Франклин)',
            'Кто не знает иностранных языков, тот ничего не знает о своем собственном. (Иоганн Гёте)',
            'Изучение языка — это не изучение слов, а изучение способа мышления. (Адриано Челентано)',
            'Если вы разговариваете с человеком на языке, который он понимает, вы обращаетесь к его голове. Если на его родном языке — к сердцу. (Нельсон Мандела)',
            'Мастерство — это не пункт назначения, а бесконечное путешествие. (Джордж Леонард)'
        ]
        return quotes[Math.floor(Math.random() * quotes.length)]
    }
}
export default MotivationalQuotesUtil
